import React from 'react';
import { termsOfServiceSections } from '../content/termsOfServiceSections';
import LegalDocumentPage from '../components/LegalDocumentPage';

const TermsOfService: React.FC = () => (
  <LegalDocumentPage title="Terms of Service" sections={termsOfServiceSections} />
);

export default TermsOfService;
